export default __webpack_public_path__ + "static/media/request_march_by_nicnubill_d7a6dq7.e57e7991.png";